import logger from '@/logger';

const log = logger.getChild('csv-upload-array-to-csv');

export const arrayToCsv = (data: string[][]): string => {
  log.log('Converting array to CSV');
  return data
    .map((row: String[]) =>
      row
        .map(String)
        .map((v) => v.replaceAll('"', '""'))
        .map((v) => `"${v}"`)
        .join(','),
    )
    .join('\r\n');
};
